/*
 *
 * Login constants
 *
 */

export const FLUSH_STATE = 'app/Login/FLUSH_STATE';

export const LOGIN_USER = 'app/Login/LOAD_USER';
export const LOGIN_USER_SUCCESS = 'app/Login/LOAD_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'app/Login/LOAD_USER_ERROR';
